import { render, staticRenderFns } from "./CFormPlan.vue?vue&type=template&id=167f87d4&scoped=true&"
import script from "./CFormPlan.vue?vue&type=script&lang=js&"
export * from "./CFormPlan.vue?vue&type=script&lang=js&"
import style0 from "./CFormPlan.vue?vue&type=style&index=0&id=167f87d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167f87d4",
  null
  
)

export default component.exports